"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _renderProp = require("../utils/propTypes/renderProp");

var _UIMedia = _interopRequireDefault(require("./UIMedia"));

var _UIMediaBody = _interopRequireDefault(require("./UIMediaBody"));

var _UIMediaLeft = _interopRequireDefault(require("./UIMediaLeft"));

var _UIMediaRight = _interopRequireDefault(require("./UIMediaRight"));

var _default = _react.default.createClass({
  displayName: "UIMediaObject",
  propTypes: (0, _extends2.default)({}, (0, _omit.default)(_UIMedia.default.propTypes, ['collapsed']), {
    itemLeft: _propTypes.default.node,
    itemLeftClassName: _propTypes.default.string,
    itemRight: _propTypes.default.node,
    itemRightClassName: _propTypes.default.string,
    MediaBody: (0, _renderProp.getPropType)(_UIMediaBody.default),
    MediaLeft: (0, _renderProp.getPropType)(_UIMediaLeft.default),
    MediaRight: (0, _renderProp.getPropType)(_UIMediaRight.default)
  }),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UIMedia.default.defaultProps, {
      MediaBody: _UIMediaBody.default,
      MediaLeft: _UIMediaLeft.default,
      MediaRight: _UIMediaRight.default
    });
  },
  render: function render() {
    var _this$props = this.props,
        align = _this$props.align,
        children = _this$props.children,
        className = _this$props.className,
        itemLeft = _this$props.itemLeft,
        itemRight = _this$props.itemRight,
        MediaBody = _this$props.MediaBody,
        MediaLeft = _this$props.MediaLeft,
        MediaRight = _this$props.MediaRight,
        spacing = _this$props.spacing,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["align", "children", "className", "itemLeft", "itemRight", "MediaBody", "MediaLeft", "MediaRight", "spacing"]);
    return _react.default.createElement(_UIMedia.default, (0, _extends2.default)({}, rest, {
      align: align,
      className: className,
      spacing: spacing
    }), itemLeft ? _react.default.createElement(MediaLeft, null, itemLeft) : null, _react.default.createElement(MediaBody, null, children), itemRight ? _react.default.createElement(MediaRight, null, itemRight) : null);
  }
});

exports.default = _default;
module.exports = exports.default;